import axios from 'axios';
import { store } from '../store';
import { setIsLoading } from '../store/slices/common';

const baseURL = process.env.REACT_APP_API_BASE;

export const defaultHeaders = {
  'Content-Type': 'application/json'
  // 'Cache-Control': 'no-cache' // 자체 캐쉬 처리되어 실제 서버를 호출하지 않는 현상 해결
};

export const createCustomInstance = (customURL, config = defaultHeaders) => {
  return axios.create({
    baseURL: customURL,
    headers: config,
    timeout: 5000, // 시간이 오래 걸리는 요청에 대한 timeout 값 재정의, 5초
    withCredentials: true
  });
};

// API instance
export const instance = createCustomInstance(baseURL);

/**
 * API 호출 전 공통 로직
 */
instance.interceptors.request.use(
  config => {
    // 요청이 전달되기 전에 작업 수행
    store.dispatch(setIsLoading(true));
    return config;
  },
  error => {
    // 요청 오류가 있는 작업 수행
    store.dispatch(setIsLoading(false));
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가하기
instance.interceptors.response.use(
  response => {
    // 2xx 범위에 있는 상태 코드는 이 함수를 트리거합니다.
    // 응답 데이터가 있는 작업 수행
    store.dispatch(setIsLoading(false));
    return response;
  },
  error => {
    // 2xx 외의 범위에 있는 상태 코드는 이 함수를 트리거합니다.
    // 응답 오류가 있는 작업 수행
    store.dispatch(setIsLoading(false));
    return Promise.reject(error);
  }
);
